import Layout from "../../components/layOutWrapper/layOutWrapper";
import ShowExpenseReportRequest from "../../components/expenseReportRequests/showExpenseReportRequest";

export default function ParticularExpenseReportRequestView () {
    return (
        <>
            <Layout children={<ShowExpenseReportRequest/>} sectionTitle="Solicitud de rendición de gastos"/>
        </>
    )
}